import script from "./DiasHorariosCancha.vue?vue&type=script&setup=true&lang=js"
export * from "./DiasHorariosCancha.vue?vue&type=script&setup=true&lang=js"

import "./DiasHorariosCancha.vue?vue&type=style&index=0&id=62adb16a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62adb16a"]])

export default __exports__